<template>
  <section class="clinicas">
    <div class="titulo">
      <div class="texto">
        <h3>Consulte las clínicas acreditadas</h3>
        <p>Reserve su cita con una clínica</p>
      </div>
      <div class="botoes">
        <button class="avancar" @click="() => { stopAutoScroll(); voltarSlide(); }">
          <img src="@images/icone-seta.svg" alt="Voltar" />
        </button>
        <button class="voltar" @click="() => { stopAutoScroll(); avancarSlide(); }">
          <img src="@images/icone-seta.svg" alt="Avançar" />
        </button>
      </div>
    </div>
    <div class="slide" ref="slide">
      <CardClinica
        v-for="clinic in clinics"
        :key="clinic.id"
        :clinic="clinic"
        @agendar="openModal"
      />
    </div>
    <Transition name="modal-animation">
      <div v-if="showModal" class="modal-overlay">
        <div class="modal">
          <button class="close" @click="closeModal">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          </button>
          <div class="modal-content">
            <div class="clinic-info">
              <div class="foto">
                <img :src="selectedClinic.logo" :alt="selectedClinic.name" @error="handleImageError">
              </div>
              <h3>{{ selectedClinic.name }}</h3>
            </div>
            <div style="display: flex; gap: 15px; width: 100%; max-width: 340px;">
              <button class="instagram" @click="openLink(selectedClinic.instagram)">
                <img src="@/assets/images/icone-instagram.png" alt="Instagram" />
                <span>{{ extractInstagramUsername(selectedClinic.instagram) }}</span>
              </button>
              <button
                class="whatsapp"
                @click="openLink(`https://wa.me/${formatWhatsAppNumber(selectedClinic.whatsapp)}`)"
              >
                <img src="@/assets/images/icone-whatsapp.png" alt="WhatsApp" />
                <p>WhatsApp</p>
              </button>
            </div>
            <button class="telefone" @click="openLink(`tel:${selectedClinic.contact}`)">
              <img src="@images/icone-telefone.svg" alt="Telefone" />
              {{ selectedClinic.contact }}
            </button>
            <div class="mapa">
              <iframe
                  width="100%"
                  height="250"
                  style="border:0"
                  loading="lazy"
                  allowfullscreen
                  :src="`https://maps.google.com/maps?q=${encodeURIComponent(selectedClinic.address)}&t=&z=15&ie=UTF8&iwloc=B&output=embed`">
              </iframe>
            </div>
            <button class="address" @click="openLink(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(selectedClinic.address)}`)">
              <span class="icon-container">
                <img src="@images/icone-localizacao.svg" alt="Endereço" />
              </span>
              {{ selectedClinic.address }}
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </section>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { db } from "@/firebaseConfig";
import { collection, getDocs } from "firebase/firestore";
import CardClinica from "@/components/global/cards/CardClinica.vue";
const defaultImage = 'https://firebasestorage.googleapis.com/v0/b/system-oligocheck.appspot.com/o/clinics%2F1757882609228_SOCHECK.jpeg?alt=media&token=6b02c18c-cc05-4d35-a4c3-f3074e6b4c3f';

const autoScrollInterval = ref(null);
const clinics = ref([]);
const showModal = ref(false);
const selectedClinic = ref(null);
const slide = ref(null);

const handleImageError = (event) => {
  event.target.src = defaultImage;
};

const larguraQuadro = 360;

const fetchClinics = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "clinics"));
    clinics.value = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error("Erro ao obter clínicas: ", error);
  }
};

const avancarSlide = () => {
  if (slide.value) {
    slide.value.scrollBy({ left: larguraQuadro, behavior: "smooth" });
  }
};

const voltarSlide = () => {
  if (slide.value) {
    slide.value.scrollBy({ left: -larguraQuadro, behavior: "smooth" });
  }
};

const openModal = (clinic) => {
  stopAutoScroll();
  selectedClinic.value = clinic;
  showModal.value = true;
};

const closeModal = () => {
  showModal.value = false;
};

const openLink = (url) => {
  window.open(url, "_blank");
};

const formatWhatsAppNumber = (number) => {
  if (!number) return "";
  return number.replace(/\D/g, "");
};



const extractInstagramUsername = (instagramUrl) => {
  try {
    const match = instagramUrl.match(/instagram\.com\/([^/?]+)/);
    return match ? `@${match[1]}` : "Instagram";
  } catch (e) {
    return "Instagram";
  }
};

onMounted(() => {
  fetchClinics();

  autoScrollInterval.value = setInterval(() => {
    avancarSlide();
  }, 3000);
});

onUnmounted(() => {
  stopAutoScroll();
});

// Função para parar o auto-scroll
const stopAutoScroll = () => {
  if (autoScrollInterval.value) {
    clearInterval(autoScrollInterval.value);
    autoScrollInterval.value = null;
  }
};
</script>

<style scoped>
section.clinicas {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0 80px 0;
  position: relative;
  background-color: var(--cor-branco);
}
.titulo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 80px;
}
.titulo .texto {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.titulo .texto h3 {
  font-family: var(--bold);
  font-size: var(--f3);
  color: var(--cor-preto);
}
.titulo .texto p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-preto);
  margin: 5px 0 0 0;
}
.titulo .botoes {
  display: flex;
  align-items: center;
}
.titulo .botoes button {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  background-color: #2280b4;
  transition: all 0.3s;
}
.titulo .botoes button:hover {
  background-color: #103e7f;
}
.titulo .botoes button.voltar {
  margin: 0 0 0 10px;
}
.titulo .botoes button.voltar img {
  transform: rotate(-180deg);
}
.titulo .botoes button img {
  width: 100%;
  max-width: 10px;
}
.slide {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  padding: 40px 80px 0 80px;
  overflow: hidden;
  scroll-behavior: smooth;
}
@media screen and (max-width: 1000px) {
  section.clinicas {
    padding: 60px 0 80px 0;
  }
  .titulo {
    flex-direction: column;
    padding: 0 20px;
  }
  .titulo .texto {
    align-items: center;
    text-align: center;
  }
  .titulo .texto h3 {
    font-size: var(--f2);
  }
  .titulo .texto p {
    font-size: var(--f1);
    margin: 10px 0 0 0;
  }
  .titulo .botoes {
    margin-top: 20px;
  }
  .slide {
    overflow: scroll;
    padding: 40px 20px 0 20px;
    scrollbar-width: none;
    scroll-snap-type: x mandatory;
    display: flex; /* Ensure flex properties are here for alignment */
    gap: 20px; /* Add some space between cards */
  }

  .slide > * {
    scroll-snap-align: center;
    flex-shrink: 0;
  }

  .slide::-webkit-scrollbar {
    display: none;
  }
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Modal box */
.modal {
  border-radius: 10px;
  width: 400px;
  max-width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  padding: 40px 0;
  position: relative;
  background-color: #F3F8FA;
  border: 1px solid #e0e0e035;
}

.modal .clinic-info {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  max-width: 340px;
  padding: 0 0 0 15px;
}

.modal .clinic-info .foto {
  margin-right: 10px;
  justify-content: left;
}
.modal .clinic-info .foto img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #2280b4;
}

.modal .close {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  color: #dd0b0b;
  cursor: pointer;
  padding: 5px;
  line-height: 0;
  opacity: 0.7;
  transition: opacity 0.3s;
}

.modal .close:hover {
  opacity: 1;
}

.modal .modal-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  row-gap: 20px;
}

.botoes-contato {
  display: flex;
  gap: 15px;
  width: 100%;
  max-width: 340px;
}

.modal .mapa {
  width: 100%;
  max-width: 340px;
  border-radius: 10px;
  overflow: hidden;
}

.modal button.whatsapp,
.modal button.instagram ,
.modal button.address,
.modal button.telefone
{
  max-width: 340px;
  margin-bottom: 15px;
}
.modal button.whatsapp {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  height: 50px;
  background-color: #2280b4;
  border-radius: 10px;
  margin: 0;
  transition: all 0.3s;
  font-family: var(--regular);
  color: white;
  font-size: 14px;
}
.modal button.whatsapp img {
  width: 100%;
  max-width: 17px;
}
.modal button.whatsapp:hover {
  background-color: #103e7f;
}
.modal button.instagram {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 50px;
  background-color: #2280b4;
  border-radius: 10px;
  margin: 0;
  transition: all 0.3s;
  gap: 10px;
  font-family: var(--regular);
  color: white;
  font-size: 14px;
  padding: 0 25px;
  overflow: hidden;
}

.modal button.instagram span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.modal button.instagram img {
  width: 100%;
  max-width: 20px;
}
.modal button.instagram:hover {
  background-color: #103e7f;
}
.modal button.telefone,
.modal button.address {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  background-color: #2280b4;
  border-radius: 10px;
  margin: 0;
  transition: all 0.3s;
  gap: 10px;
  font-family: var(--regular);
  color: white;
  font-size: 14px;
}
.modal button.address {
  font-size: 13px;
  padding: 15px 25px;
  width: auto;
  height: auto;
  justify-content: flex-start;
  text-align: left;
  line-height: 1.4;
}
.modal button.address  img {
  width: 100%;
  max-width: 14px;
}

.modal button.telefone img{
  width: 100%;
  max-width: 15px;
}
.modal button.telefone:hover {
  background-color: #103e7f;
}
.modal .nome {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 0 0 15px;
  margin-right: auto;
}
.modal h3 {
  font-family: var(--bold);
  font-size: var(--f2);
  color: var(--cor-preto);
  text-align: left;
}
.icon-container {
  color: #2280b4;
  display: flex;
  align-items: center;
}

.modal-animation-enter-active,
.modal-animation-leave-active {
  transition: opacity 0.3s cubic-bezier(0.52, 0.02, 0.19, 1.02);
}

.modal-animation-enter-from,
.modal-animation-leave-to {
  opacity: 0;
}

.modal-animation-enter-active .modal,
.modal-animation-leave-active .modal {
  transition: all 0.3s cubic-bezier(0.52, 0.02, 0.19, 1.02);
}

.modal-animation-enter-from .modal,
.modal-animation-leave-to .modal {
  opacity: 0;
  transform: scale(0.95);
}

@media screen and (max-width: 1000px) {
  .modal {
    margin: 0 20px;
    width: calc(100% - 40px);
    padding: 30px 15px;
  }
  .modal-content {
    row-gap: 8px;
  }
  .modal button.whatsapp,
  .modal button.instagram,
  .modal button.address,
  .modal button.telefone {
    height: 45px;
    font-size: 13px;
    padding: 0 15px;
  }
  .modal button.address {
    padding: 10px 20px;
    width: 100%;
    height: auto;
  }
  .modal .mapa {
    height: 200px;
  }
}
</style>
